import { ModalType } from '@/Enums/Whitelabels/ModalType.enum';
import WhitelabelDomainStatus from '@/Enums/Whitelabels/WhitelabelDomainStatus.enum';
import { WhitelabelType } from '@/Enums/Whitelabels/WhitelabelType.enum';
import { IWhitelabelFormData } from '@/Interfaces/Whitelabels/WhitelabelFormData.interface';

export const MODAL_TITLES: Record<ModalType, string> = {
  [ModalType.New]: 'Create New Whitelabel',
  [ModalType.View]: 'Edit Whitelabel',
};

export const WHITELABEL_TYPE_LABELS: Record<WhitelabelType, string> = {
  [WhitelabelType.Organization]: 'Organization Name',
  [WhitelabelType.Whitelabel]: 'Whitelabel Name',
};

export const DEFAULT_WHITELABEL: IWhitelabelFormData = {
  id: 0,
  name: '',
  type: WhitelabelType.Whitelabel,
  organization: { value: null, label: '' },
  sidebarTextColor: '',
  loginTextDark: false,
  loginBg: '',
  buttonBg: '',
  sidebarBg: '',
  domain: '',
  mainLogo: '',
  favicon: '',
  sidebarLogo: '',
  requiresCampaignApproval: false,
  sendEmailNotification: false,
  domainStatus: WhitelabelDomainStatus.Success,
  domainVerificationRecord: '',
  domainExternal: '',
  domainExternalStatus: WhitelabelDomainStatus.Pending,
};

export const REQUEST_ABORT_IDS = {
  WHITELABELS: 'WHITELABELS_WHITELABELS',
  SELECTED_WHITELABEL: 'WHITELABELS_SELECTED_WHITELABEL',
};
